import JobWorkerInterviewContactDeclinedReason from "@/models/JobWorkerInterviews/JobWorkerInterviewContactDeclinedReason";

export default class AnonJobWorkerInterviewContactConfirmationReply 
{ 
	confirmed = false;
	declinedReason: JobWorkerInterviewContactDeclinedReason = JobWorkerInterviewContactDeclinedReason.Undefined;
}